import React from "react";
import { makeStyles, Typography, Grid } from "@material-ui/core";
import { Icon } from "../../../../../components/base";
import { COLORS } from "../../../../../theme/colors";

export const useStyles = makeStyles(() => ({
  rightContent: {
    backgroundColor: COLORS.purple,
    height: 40,
    width: 40,
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  shortName: {
    fontSize: 16,
    color: COLORS.white,
  },
  profileLabel: {
    fontSize: 14,
    fontWeight: 400,
  },
  avatarIconButton: {
    borderRadius: 100,
    width: 40,
    height: 40,
  },
  card: {
    display: "flex",
    alignItems: "center",
    marginTop: 10,
  },
}));

const ProficePic = ({ uploadImage, user, UploadButton, uploading }) => {
  const classes = useStyles();
  return (
    <Grid>
      <Typography variant="h6" className={classes.profileLabel}>
        Profile picture
      </Typography>
      <Grid className={classes.card}>
        {user?.avatar_url ? (
          <Icon src={user?.avatar_url} root={classes.avatarIconButton} />
        ) : (
          <Grid className={classes.rightContent}>
            <Typography className={classes.shortName}>DN</Typography>
          </Grid>
        )}
        <Grid>
          <UploadButton
            containerStyle={{ marginLeft: "10px" }}
            accept="image/png, image/jpeg, image/svg, image/gif"
            loading={uploading}
            onChange={uploadImage}
            text="Upload profile picture"
            onlyText
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ProficePic;
